export enum AuthProviderType {
  Unknown = 'unknown',
  Auth0 = 'auth0',
  Teams = 'teams',
  AzureActiveDirectory = 'aad'
}
